package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Stage
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.StageState
import org.jetbrains.compose.web.css.px

@Composable
fun InternshipAccordionContent(
    onComplete: (String) -> Unit,
    onAddFormationAndClose: (String) -> Unit
) {
    val cvViewModel = koinGet<CvViewModel>()
    val stagesFromVM = cvViewModel.cvUiState.data.stages

    LaunchedEffect(Unit) {
        if (stagesFromVM.isEmpty()) {
            cvViewModel.updateStage(0, Stage("", "", "", "", "", ""))
            cvViewModel.editingStageId = "stage-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        stagesFromVM.forEachIndexed { index, stageData ->
            val tempId = "stage-$index"

            val state = remember(stageData) {
                val startParts = stageData.started.split("-")
                val endParts = stageData.ended.split("-")
                StageState(
                    id = tempId,
                    poste = stageData.post,
                    employeur = stageData.enterprise,
                    ville = stageData.city,
                    moisDebut = startParts.getOrNull(0) ?: "",
                    anneeDebut = startParts.getOrNull(1) ?: "",
                    moisFin = if (stageData.ended == "En cours") "" else (endParts.getOrNull(0) ?: ""),
                    anneeFin = if (stageData.ended == "En cours") "" else (endParts.getOrNull(1) ?: ""),
                    isOngoing = stageData.ended == "En cours",
                    description = stageData.description
                )
            }

            GenericFormCard(
                item = state,
                isEditing = cvViewModel.editingStageId == tempId,
                onEdit = { cvViewModel.editingStageId = tempId },
                onDelete = {
                    cvViewModel.deleteStage(index)
                    if (cvViewModel.cvUiState.data.stages.isEmpty()) {
                        cvViewModel.updateStage(0, Stage("", "", "", "", "", ""))
                        cvViewModel.editingStageId = "stage-0"
                    } else {
                        cvViewModel.editingStageId = null
                    }
                },
                onComplete = { cvViewModel.editingStageId = null },
                getSummary = { s ->
                    if (s.poste.isNotBlank() || s.employeur.isNotBlank()) {
                        SummaryData(
                            title = s.poste.ifBlank { "[Poste]" },
                            subtitle = s.employeur.ifBlank { "[Employeur]" }
                        )
                    } else null
                },
                getDefaultText = { "[Stages]" },
                formContent = { s, onDel, onComp ->
                    InternshipForm(
                        index = index,
                        state = s,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter un stage",
            onClick = {
                val nextIndex = stagesFromVM.size
                cvViewModel.updateStage(nextIndex, Stage("", "", "", "", "", ""))
                cvViewModel.editingStageId = "stage-$nextIndex"
            }
        )
    }
}